import { useState, useEffect } from "react";

export default function usePersistedState(
  key,
  defaultValue,
  storage = typeof window !== "undefined" ? window.sessionStorage : undefined,
) {
  const [value, setValue] = useState(() => {
    try {
      if (!storage) return defaultValue;
      const raw = storage.getItem(key);
      if (raw === null || raw === undefined) return defaultValue;
      return JSON.parse(raw);
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      if (!storage) return;
      storage.setItem(key, JSON.stringify(value));
    } catch {
      // storage full / disabled - ignore, in-memory state still works
    }
  }, [key, value, storage]);

  return [value, setValue];
}

export function clearPersistedPageIndexes() {
  try {
    if (typeof window === "undefined") return;
    const storage = window.sessionStorage;
    Object.keys(storage)
      .filter((k) => k.startsWith("pageIndex"))
      .forEach((k) => storage.removeItem(k));
  } catch {
    // ignore
  }
}

